import { render, staticRenderFns } from "./ModalEditPatientAddress.vue?vue&type=template&id=2492558e&scoped=true"
import script from "./ModalEditPatientAddress.vue?vue&type=script&lang=js"
export * from "./ModalEditPatientAddress.vue?vue&type=script&lang=js"
import style0 from "./ModalEditPatientAddress.vue?vue&type=style&index=0&id=2492558e&prod&lang=scss&scoped=true"
import style1 from "./ModalEditPatientAddress.vue?vue&type=style&index=1&id=2492558e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2492558e",
  null
  
)

export default component.exports